import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { InductionVM, ModalNewCategory, ModalNewSection, ModalUpdateCategory, ModalUpdateSection } from '../config-setup-inductionand-sections/config-setup-inductionand-sections';
import { AddCompletedDigitalFormReqVM, DeleteFormVM, GetEditDigitalFormVM, VMDataForUpload } from '../entities/global/model';
import { ModelAnswerList } from '../favourite-dialog/favourite-dialog-modal';
import { AddNewDigitalQuestionsVM, AnswerListVM, CreateExternalAttendeeVM, CreateNewInductionVM, DigitalFormSetupVM, Form, FormUploadVM, IndcutionSearchVM, InductionExternalAttendeeseVM, InductionM, InspectionSearchResultsVM, ModalFormCatData, ModalFormData, ModalToggleForm, SafetyInpsectionSearchVM, SaveAnswerForDigitalFormQuestionVM, SearchByParametersSafetySearchVM, SearchByParametersVM, SearchFormVM, StateVM, TrainingRegFormsVM, TraningRegSearchParametersVM, TraningRegUserVM, UpdateDigitalFormNameVM, UpdateDigitalFormSectionVM, UploadDigitalFormQuestionImageVM, VMCreateCategory, VMFormSearch } from '../perform-induction/perform-induction';
import { Tuple } from '../setup-equipment/setup-equipment.model';
import { AddQuestionAnsVM, InductionQuestionsVM, InductionSlides, ModalAddNewQuestions } from '../setup-induction-question/setup-induction-question';
import { CreateSlideVM, TogleSlideVM, UpdateSlideVM } from '../setup-induction-slides/setup-induction-slides';
import { UserOverviewModel } from '../../../entities/global/model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, share } from 'rxjs/operators';
@Injectable()
export class SafetyInductionService {

  constructor(private _http: HttpClient) {

  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  //set up induction type and section

  public CreateNewCategory(newCategory: ModalNewCategory): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/CreateInductionTypes", newCategory)
      .pipe(
        map(response => response as Tuple),
        catchError(this.handleError)
      );
  }
  
  public GetInductionTypes(): Observable<InductionVM> {
    return this._http.get<InductionVM>("api/InductionTypes/GetInductionTypes")
      .pipe(
        map(response => response as InductionVM),
        catchError(this.handleError)
      );
  }
  
  public CreateInductionSelections(newSection: ModalNewSection): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/CreateInductionSelections", newSection)
      .pipe(
        map(response => response as Tuple),
        catchError(this.handleError)
      );
  }
  
  public UpdateCategory(UpdateCat: ModalUpdateCategory): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/UpdateInductionType", UpdateCat)
      .pipe(
        map(response => response as Tuple),
        catchError(this.handleError)
      );
  }
  
  public UpdateSection(UpdateSection: ModalUpdateSection): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/UpdateSelections", UpdateSection)
      .pipe(
        map(response => response as Tuple),
        catchError(this.handleError)
      );
  }
  
  public OrderUp_InductionSlide(sectionID: number, Order: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('sectionID', sectionID.toString())
        .set('Order', Order.toString())
    };
    return this._http.get<boolean>("api/InductionTypes/OrderUp_InductionSlide", options)
      .pipe(
        map(response => response as boolean),
        catchError(this.handleError)
      );
  }
  
  public OrderDown_InductionSlide(sectionID: number, Order: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('sectionID', sectionID.toString())
        .set('Order', Order.toString())
    };
    return this._http.get<boolean>("api/InductionTypes/OrderDown_InductionSlide", options)
      .pipe(
        map(response => response as boolean),
        catchError(this.handleError)
      );
  }
  
  public OrderUp_InductionCategories(CatId: number, Order: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('CatId', CatId.toString())
        .set('Order', Order.toString())
    };
    return this._http.get<boolean>("api/InductionTypes/OrderUp_InductionCategories", options)
      .pipe(
        map(response => response as boolean),
        catchError(this.handleError)
      );
  }
  
  public OrderDown_InductionCategories(CatId: number, Order: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('CatId', CatId.toString())
        .set('Order', Order.toString())
    };
    return this._http.get<boolean>("api/InductionTypes/OrderDown_InductionCategories", options)
      .pipe(
        map(response => response as boolean),
        catchError(this.handleError)
      );
  }
  // public CreateNewCategory(newCategory: ModalNewCategory): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/CreateInductionTypes", newCategory).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public GetInductionTypes(): Observable<InductionVM> {
  //   return this._http.get("api/InductionTypes/GetInductionTypes").share().map(
  //     (response: Response) => <InductionVM>response.json()).catch(this.handleError);
  // }

  // public CreateInductionSelections(newSection: ModalNewSection): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/CreateInductionSelections", newSection).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public UpdateCategory(UpdateCat: ModalUpdateCategory): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/UpdateInductionType", UpdateCat).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public UpdateSection(UpdateSection: ModalUpdateSection): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/UpdateSelections", UpdateSection).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public OrderUp_InductionSlide(sectionID: number, Order: number): Observable<boolean> {
  //   const options = {
  //     params: new HttpParams().set('sectionID', sectionID.toString())
  //     .set('Order', Order.toString())
  //   };
  //   return this._http.get("api/InductionTypes/OrderUp_InductionSlide", options).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }

  // public OrderDown_InductionSlide(sectionID: number, Order: number): Observable<boolean> {
  //   const options = {
  //     params: new HttpParams().set('sectionID', sectionID.toString())
  //     .set('Order', Order.toString())
  //   };
  //   return this._http.get("api/InductionTypes/OrderDown_InductionSlide", options).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }


  // public OrderUp_InductionCategories(CatId: number, Order: number): Observable<boolean> {
  //   const options = {
  //     params: new HttpParams().set('CatId', CatId.toString())
  //     .set('Order', Order.toString())
  //   };
  //   return this._http.get("api/InductionTypes/OrderUp_InductionCategories", options).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }

  // public OrderDown_InductionCategories(CatId: number, Order: number): Observable<boolean> {
  //   const options = {
  //     params: new HttpParams().set('CatId', CatId.toString())
  //     .set('Order', Order.toString())
  //   };
  //   return this._http.get("api/InductionTypes/OrderDown_InductionCategories", options).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }

  //setup induction question

  public SetupQuestions(ID: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('ID', ID.toString())
    };
    return this._http.get<Tuple>("api/InductionTypes/SetupQuestions", options)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  public AddNewQuestions(newQuestion: ModalAddNewQuestions): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/AddNewQuestions", newQuestion)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  public ToggleInductionQuestion(questionId: number, active: boolean = false): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('questionId', questionId.toString())
        .set('active', active.toString())
    };
    return this._http.get<Tuple>("api/InductionTypes/ToggleInductionQuestion", options)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  public SaveAnswerForQuestion(newQuestion: AddQuestionAnsVM): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/SaveAnswerForQuestion", newQuestion)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  public GetAnswerListForQuestionId(QId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('QId', QId.toString())
    };
    return this._http.get<Tuple>("api/InductionTypes/GetAnswerListForQuestionId", options)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  public UpdateQuestions(newQuestion: ModalAddNewQuestions): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/UpdateQuestions", newQuestion)
      .pipe(
        catchError(this.handleError)
      );
  }
  // public SetupQuestions(ID: number): Observable<Tuple> {
  //   const options = {
  //     params: new HttpParams().set('ID', ID.toString())
  //   };
  //   return this._http.get("api/InductionTypes/SetupQuestions", options).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public AddNewQuestions(newQuestion: ModalAddNewQuestions): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/AddNewQuestions", newQuestion).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public ToggleInductionQuestion(questionId: number, active: boolean = false): Observable<Tuple> {
  //   const options = {
  //     params: new HttpParams().set('questionId', questionId.toString())
  //     .set('active', active.toString())
  //   };
  //   return this._http.get("api/InductionTypes/ToggleInductionQuestion", options).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public SaveAnswerForQuestion(newQuestion: AddQuestionAnsVM): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/SaveAnswerForQuestion", newQuestion).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public GetAnswerListForQuestionId(QId: number): Observable<Tuple> {
  //   const options = {
  //     params: new HttpParams().set('QId', QId.toString())
  //   };
  //   return this._http.get("api/InductionTypes/GetAnswerListForQuestionId", options).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public UpdateQuestions(newQuestion: ModalAddNewQuestions): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/UpdateQuestions", newQuestion).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  //Setup slides


  public ToggleSlide(newQuestion: TogleSlideVM): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/ToggleSlide", newQuestion)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UpdateSlides(updateSlide: UpdateSlideVM): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/UpdateSlides", updateSlide)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public CreateSlide(addSlide: CreateSlideVM): Observable<Tuple> {
    return this._http.post<Tuple>("api/InductionTypes/CreateSlide", addSlide)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetSlideInfoById(ID: number): Observable<InductionSlides> {
    const options = {
      params: new HttpParams().set('Id', ID.toString())
    };
    return this._http.get<InductionSlides>("api/InductionTypes/GetSlideInfoById", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GETPerfomeInduction(): Observable<Tuple> {
    return this._http.get<Tuple>("api/PerfomeInduction/GETPerfomeInduction")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public CreateNewInduction(addInduction: CreateNewInductionVM): Observable<number> {
    return this._http.post<number>("api/PerfomeInduction/CreateNewInduction", addInduction)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SearchExternalAttendee(Fname: string, Lname: string, Company: string, Position: string, Email: string): Observable<InductionExternalAttendeeseVM[]> {
    const options = {
      params: new HttpParams()
        .set('Fname', Fname)
        .set('Lname', Lname)
        .set('Company', Company)
        .set('Position', Position)
        .set('Email', Email)
    };
    return this._http.get<InductionExternalAttendeeseVM[]>("api/PerfomeInduction/SearchExternalAttendee", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public CreateExternalAttendee(addExAttendee: CreateExternalAttendeeVM): Observable<InductionExternalAttendeeseVM> {
    return this._http.post<InductionExternalAttendeeseVM>("api/PerfomeInduction/CreateExternalAttendee", addExAttendee)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public StartInduction(Id: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<Tuple>("api/PerfomeInduction/StartInduction", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetSlidesInfo(Id: number): Observable<InductionSlides[]> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<InductionSlides[]>("api/PerfomeInduction/GetSlidesInfo", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetImageBase64Data(Id: number): Observable<string> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<string>("api/PerfomeInduction/GetImageBase64Data", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetQuestionsAnswersForSection(Id: number): Observable<InductionQuestionsVM[]> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<InductionQuestionsVM[]>("api/PerfomeInduction/GetQuestionsAnswersForSection", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SearchInductions(): Observable<Tuple> {
    return this._http.get<Tuple>("api/PerfomeInduction/Search")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetInductionSearch(DateCompletedStart: any, DateCompletedEnd: any, inductiontype: number | null, fname: string, lname: string, email: string, company: string, valid: boolean | null, Invalid: boolean | null, State: number | null, facilitator: number | null): Observable<IndcutionSearchVM[]> {
    const options = {
      params: new HttpParams()
        .set('DateCompletedStart', DateCompletedStart)
        .set('DateCompletedEnd', DateCompletedEnd)
        .set('inductiontype', inductiontype?.toString() || '')
        .set('fname', fname)
        .set('lname', lname)
        .set('email', email)
        .set('company', company)
        .set('valid', valid?.toString() || '')
        .set('Invalid', Invalid?.toString() || '')
        .set('State', State?.toString() || '')
        .set('facilitator', facilitator?.toString() || '')
    };
    return this._http.get<IndcutionSearchVM[]>("api/PerfomeInduction/SearchInduction", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GETSetupForms(): Observable<Tuple> {
    return this._http.get<Tuple>("api/SaftyForms/GETSetupForms")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  // public ToggleSlide(newQuestion: TogleSlideVM): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/ToggleSlide", newQuestion).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public UpdateSlides(updateSlide: UpdateSlideVM): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/UpdateSlides", updateSlide).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }
  // public CreateSlide(addSlide: CreateSlideVM): Observable<Tuple> {
  //   return this._http.post("api/InductionTypes/CreateSlide", addSlide).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public GetSlideInfoById(ID: number): Observable<InductionSlides> {
  //   const options = {
  //     params: new HttpParams().set('Id', ID.toString())
  //   };
  //   return this._http.get("api/InductionTypes/GetSlideInfoById", options).share().map(
  //     (response: Response) => <InductionSlides>response.json()).catch(this.handleError);
  // }

  // //perform induction
  // public GETPerfomeInduction(): Observable<Tuple> {
  //   return this._http.get("api/PerfomeInduction/GETPerfomeInduction").share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public CreateNewInduction(addInduction: CreateNewInductionVM): Observable<number> {
  //   return this._http.post("api/PerfomeInduction/CreateNewInduction", addInduction).share().map(
  //     (response: Response) => <number>response.json()).catch(this.handleError);
  // }

  // public SearchExternalAttendee(Fname: string,
  //   Lname: string, Company: string, Position: string, Email: string,): Observable<InductionExternalAttendeeseVM[]> {
  //   const options = {
  //     params: new HttpParams().set('Fname', Fname.toString())
  //     .set('Lname', Lname.toString())
  //     .set('Company', Company.toString())
  //     .set('Position', Position.toString())
  //     .set('Email', Email.toString())
  //   };
  //   return this._http.get("api/PerfomeInduction/SearchExternalAttendee", options).share().map(
  //     (response: Response) => <InductionExternalAttendeeseVM[]>response.json()).catch(this.handleError);
  // }

  // public CreateExternalAttendee(addExAttendee: CreateExternalAttendeeVM): Observable<InductionExternalAttendeeseVM> {
  //   return this._http.post("api/PerfomeInduction/CreateExternalAttendee", addExAttendee).share().map(
  //     (response: Response) => <InductionExternalAttendeeseVM>response.json()).catch(this.handleError);
  // }


  // public StartInduction(Id: number): Observable<Tuple> {
  //   const options = {
  //     params: new HttpParams().set('Id', Id.toString())
  //   };
  //   return this._http.get("api/PerfomeInduction/StartInduction", options).share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public GetSlidesInfo(Id: number): Observable<InductionSlides[]> {
  //   const options = {
  //     params: new HttpParams().set('Id', Id.toString())
  //   };
  //   return this._http.get("api/PerfomeInduction/GetSlidesInfo", options).share().map(
  //     (response: Response) => <InductionSlides[]>response.json()).catch(this.handleError);
  // }

  // public GetImageBase64Data(Id: number): Observable<string> {
  //   const options = {
  //     params: new HttpParams().set('Id', Id.toString())
  //   };
  //   return this._http.get("api/PerfomeInduction/GetImageBase64Data", options).share().map(
  //     (response: Response) => <string>response.json()).catch(this.handleError);
  // }

  // public GetQuestionsAnswersForSection(Id: number): Observable<InductionQuestionsVM[]> {
  //   const options = {
  //     params: new HttpParams().set('Id', Id.toString())
  //   };
  //   return this._http.get("api/PerfomeInduction/GetQuestionsAnswersForSection", options).share().map(
  //     (response: Response) => <InductionQuestionsVM[]>response.json()).catch(this.handleError);
  // }
  
  // public SearchInductions(): Observable<Tuple> {
  //   return this._http.get("api/PerfomeInduction/Search").share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  // public GetInductionSearch(DateCompletedStart: any, DateCompletedEnd:any, 
  //   inductiontype:number|null,fname:string, lname:string,email:string, 
  //   company:string,valid:boolean|null,Invalid:boolean|null,State:number|null, facilitator:number|null
  //   ): Observable<IndcutionSearchVM[]> {
  //     const options = {
  //       params: new HttpParams().set('DateCompletedStart', DateCompletedStart)
  //       .set('DateCompletedEnd', DateCompletedEnd)
  //       .set('inductiontype', inductiontype.toString())
  //       .set('fname', fname)
  //       .set('lname', lname)
  //       .set('email', email)
  //       .set('company', company)
  //       .set('valid', valid.toString())
  //       .set('Invalid', Invalid.toString())
  //       .set('State', State.toString())
  //       .set('facilitator', facilitator.toString())
  //     };
  //   return this._http.get("api/PerfomeInduction/SearchInduction", options).share().map(
  //     (response: Response) => <IndcutionSearchVM[]>response.json()).catch(this.handleError);
  // }
  
  // //Forms Setup
  
  // public GETSetupForms(): Observable<Tuple> {
  //   return this._http.get("api/SaftyForms/GETSetupForms").share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }

  public ToggleIncidentNoRequired(modalRequired: ModalToggleForm): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/ToggleIncidentNoRequired", modalRequired)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public ToggleForm(modalRequired: ModalToggleForm): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/ToggleForm", modalRequired)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public FormUpdate(_form: ModalFormData): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/FormUpdate", _form)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UpdateFormCategory(_form: ModalFormCatData): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/UpdateFormCategory", _form)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public CreateForm(_form: ModalFormData): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/CreateForm", _form)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public AddnewfFormCategory(_form: VMCreateCategory): Observable<boolean> {
    return this._http.post<boolean>("api/SaftyForms/CreateCategory", _form)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public CreateDigitalForm(_form: ModalFormData): Observable<number> {
    return this._http.post<number>("api/SaftyForms/CreateDigitalForm", _form)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GETDigitalFormSetup(CatId: number): Observable<DigitalFormSetupVM> {
    const options = {
      params: new HttpParams().set('Id', CatId.toString())
    };
    return this._http.get<DigitalFormSetupVM>("api/SafetyDigitalForm/GETDigitalFormSetup", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public ToggleDigitalFormEmailOnComplete(FormId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('FormId', FormId.toString())
    };
    return this._http.get<boolean>("api/SafetyDigitalForm/ToggleDigitalFormEmailOnComplete", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public ToggleDigitalFormQuestion(QId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('questionId', QId.toString()).set('active', "false")
    };
    return this._http.get<boolean>("api/SafetyDigitalForm/ToggleDigitalFormQuestion", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public ToggleImageEdit(QId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('questionId', QId.toString())
    };
    return this._http.get<boolean>("api/SafetyDigitalForm/ToggleImageEdit", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public ToggleAllowImage(QId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('questionId', QId.toString())
    };
    return this._http.get<boolean>("api/SafetyDigitalForm/ToggleAllowImage", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public AddNewDigitalQuestions(question: AddNewDigitalQuestionsVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/AddNewDigitalQuestions", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UpdateDigitalFormQuestion(question: AddNewDigitalQuestionsVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/UpdateDigitalFormQuestion", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public AddNewDigitalFormSection(question: UpdateDigitalFormSectionVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/AddNewDigitalFormSection", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UpdateDigitalFormSection(question: UpdateDigitalFormSectionVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/UpdateDigitalFormSection", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetAnswerListForDigitalFormQuestionId(QId: number): Observable<AnswerListVM[]> {
    const options = {
      params: new HttpParams().set('QId', QId.toString())
    };
    return this._http.get<AnswerListVM[]>("api/SafetyDigitalForm/GetAnswerListForDigitalFormQuestionId", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public uploadFormData(Id: number): Observable<VMDataForUpload> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<VMDataForUpload>("api/SaftyForms/Upload", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GETFormUploadData(FormId: number): Observable<GetEditDigitalFormVM> {
    const options = {
      params: new HttpParams().set('FormId', FormId.toString())
    };
    return this._http.get<GetEditDigitalFormVM>("api/SafetyDigitalForm/GETDigitalFormUpload", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
//   public ToggleIncidentNoRequired(modalRequired: ModalToggleForm): Observable<boolean> {
//     return this._http.post("api/SaftyForms/ToggleIncidentNoRequired", modalRequired).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public ToggleForm(modalRequired: ModalToggleForm): Observable<boolean> {
//     return this._http.post("api/SaftyForms/ToggleForm", modalRequired).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public FormUpdate(_form: ModalFormData): Observable<boolean> {
//     return this._http.post("api/SaftyForms/FormUpdate", _form).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public UpdateFormCategory(_form: ModalFormCatData): Observable<boolean> {
//     return this._http.post("api/SaftyForms/UpdateFormCategory", _form).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public CreateForm(_form: ModalFormData): Observable<boolean> {
//     return this._http.post("api/SaftyForms/CreateForm", _form).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }
// //carate Form category

// public AddnewfFormCategory(_form: VMCreateCategory): Observable<boolean> {
//   return this._http.post("api/SaftyForms/CreateCategory", _form).share().map(
//     (response: Response) => <boolean>response.json()).catch(this.handleError);
// }


//   public CreateDigitalForm(_form: ModalFormData): Observable<number> {
//     return this._http.post("api/SaftyForms/CreateDigitalForm", _form).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }

//   //digital form
//   public GETDigitalFormSetup(CatId:number): Observable<DigitalFormSetupVM> {
//     const options = {
//       params: new HttpParams().set('Id', CatId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/GETDigitalFormSetup", options).share().map(
//       (response: Response) => <DigitalFormSetupVM>response.json()).catch(this.handleError);
//   }

//   public ToggleDigitalFormEmailOnComplete(FormId:number): Observable<boolean> {
//     const options = {
//       params: new HttpParams().set('FormId', FormId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/ToggleDigitalFormEmailOnComplete", options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public ToggleDigitalFormQuestion(QId:number): Observable<boolean> {
//     const options = {
//       params: new HttpParams().set('questionId', QId.toString())
//       .set('active', "false")
//     };
//     return this._http.get("api/SafetyDigitalForm/ToggleDigitalFormQuestion", options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public ToggleImageEdit(QId:number): Observable<boolean> {
//     const options = {
//       params: new HttpParams().set('questionId', QId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/ToggleImageEdit", options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public ToggleAllowImage(QId:number): Observable<boolean> {
//     const options = {
//       params: new HttpParams().set('questionId', QId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/ToggleAllowImage", options).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

// public AddNewDigitalQuestions(question: AddNewDigitalQuestionsVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/AddNewDigitalQuestions", question).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }

//   public UpdateDigitalFormQuestion(question: AddNewDigitalQuestionsVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/UpdateDigitalFormQuestion", question).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }

//   public AddNewDigitalFormSection(question: UpdateDigitalFormSectionVM): Observable<number> {
//     console.log('question', "" + question);

//     return this._http.post("api/SafetyDigitalForm/AddNewDigitalFormSection", question).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }

//   public UpdateDigitalFormSection(question: UpdateDigitalFormSectionVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/UpdateDigitalFormSection", question).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }

  
//   public GetAnswerListForDigitalFormQuestionId(QId:number): Observable<AnswerListVM[]> {
//     const options = {
//       params: new HttpParams().set('QId', QId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/GetAnswerListForDigitalFormQuestionId", options).share().map(
//       (response: Response) => <AnswerListVM[]>response.json()).catch(this.handleError);
//   }
// //get upload from data================
// public uploadFormData(Id:number): Observable<VMDataForUpload> {
//   const options = {
//     params: new HttpParams().set('Id', Id.toString())
//   };
//   return this._http.get("api/SaftyForms/Upload", options).share().map(
//     (response: Response) => <VMDataForUpload>response.json()).catch(this.handleError);
// }


//   public GETFormUploadData(FormId:number): Observable<GetEditDigitalFormVM> {
//     const options = {
//       params: new HttpParams().set('FormId', FormId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/GETDigitalFormUpload", options).share().map(
//       (response: Response) => <GetEditDigitalFormVM>response.json()).catch(this.handleError);
//   }

  public GetAnswerListForUploadFormDigitalQuestion(QId: number): Observable<ModelAnswerList[]> {
    const options = {
      params: new HttpParams().set('QId', QId.toString())
    };
    return this._http.get<ModelAnswerList[]>("api/SafetyDigitalForm/GetAnswerListForUploadFormDigitalQuestion", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GETFormUploadDataEdit(Id: number): Observable<GetEditDigitalFormVM> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<GetEditDigitalFormVM>("api/SafetyDigitalForm/GetEditDigitalForm", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public AddCompletedDigitalForm(addForms: AddCompletedDigitalFormReqVM): Observable<boolean> {
    return this._http.post<boolean>("api/SafetyDigitalForm/AddCompletedDigitalForm", addForms)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public EditCompletedDigitalForm(addForms: AddCompletedDigitalFormReqVM): Observable<boolean> {
    return this._http.post<boolean>("api/SafetyDigitalForm/EditCompletedDigitalForm", addForms)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public DeleteForm(addForms: DeleteFormVM): Observable<boolean> {
    return this._http.post<boolean>("api/SafetyDigitalForm/DeleteForm", addForms)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SaveAnswerForDigitalFormQuestion(question: SaveAnswerForDigitalFormQuestionVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/SaveAnswerForDigitalFormQuestion", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SaveAnswerForAdditonalObservation(question: SaveAnswerForDigitalFormQuestionVM): Observable<boolean> {
    return this._http.post<boolean>("api/Inspection/SaveAnswerForAdditonalObservation", question)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetFormSearch(): Observable<VMFormSearch> {
    return this._http.get<VMFormSearch>("api/SaftyForms/Search")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public TrainingRegisterGetStates(): Observable<StateVM[]> {
    return this._http.get<StateVM[]>("api/SaftyForms/TrainingRegisterGetStates")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SearchByParameters(_SearchByParameters: SearchByParametersVM): Observable<FormUploadVM[]> {
    return this._http.post<FormUploadVM[]>("api/SaftyForms/SearchByParameters", _SearchByParameters)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetFormFileData(Id: number): Observable<string> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<string>("api/SaftyForms/GetFormFileData", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetFormFileDataForNew(Id: number): Observable<string> {
    const options = {
      params: new HttpParams().set('Id', Id.toString())
    };
    return this._http.get<string>("api/SaftyForms/GetFormFileDataNEW", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
//   public GetAnswerListForUploadFormDigitalQuestion(QId:number): Observable<ModelAnswerList[]> {
//     const options = {
//       params: new HttpParams().set('QId', QId.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/GetAnswerListForUploadFormDigitalQuestion", options).share().map(
//       (response: Response) => <ModelAnswerList[]>response.json()).catch(this.handleError);
//   }
// //Edit digital Form
//   public GETFormUploadDataEdit(Id:number): Observable<GetEditDigitalFormVM> {
//     const options = {
//       params: new HttpParams().set('Id', Id.toString())
//     };
//     return this._http.get("api/SafetyDigitalForm/GetEditDigitalForm", options).share().map(
//       (response: Response) => <GetEditDigitalFormVM>response.json()).catch(this.handleError);
//   }

//   public AddCompletedDigitalForm(addForms: AddCompletedDigitalFormReqVM): Observable<boolean> {
//     return this._http.post("api/SafetyDigitalForm/AddCompletedDigitalForm", addForms).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }
//   //Add Digital from with state

// //edit from  
//   public EditCompletedDigitalForm(addForms: AddCompletedDigitalFormReqVM): Observable<boolean> {
//     return this._http.post("api/SafetyDigitalForm/EditCompletedDigitalForm", addForms).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   //delete Form
//   public DeleteForm(addForms: DeleteFormVM): Observable<boolean> {
//     return this._http.post("api/SafetyDigitalForm/DeleteForm", addForms).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

//   public SaveAnswerForDigitalFormQuestion(question: SaveAnswerForDigitalFormQuestionVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/SaveAnswerForDigitalFormQuestion", question).share().map(
//       (response: Response) => <number>response.json()).catch(this.handleError);
//   }
// public SaveAnswerForAdditonalObservation(question: SaveAnswerForDigitalFormQuestionVM): Observable<boolean> {
//     return this._http.post("api/Inspection/SaveAnswerForAdditonalObservation", question).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }
  
//   //Form Search
//   public GetFormSearch(): Observable<VMFormSearch> {
    
//     return this._http.get("api/SaftyForms/Search").share().map(
//       (response: Response) => <VMFormSearch>response.json()).catch(this.handleError);
//   }
//   public TrainingRegisterGetStates(): Observable<StateVM[]> {

//     return this._http.get("api/SaftyForms/TrainingRegisterGetStates").share().map(
//       (response: Response) => <StateVM[]>response.json()).catch(this.handleError);
//   }

//   public SearchByParameters(_SearchByParameters:SearchByParametersVM): Observable<FormUploadVM[]> {
//     return this._http.post("api/SaftyForms/SearchByParameters",_SearchByParameters).share().map(
//       (response: Response) => <FormUploadVM[]>response.json()).catch(this.handleError);
//   }

//   public GetFormFileData(Id:number): Observable<string> {
//     const options = {
//       params: new HttpParams().set('Id', Id.toString())
//     };
//     return this._http.get("api/SaftyForms/GetFormFileData", options).share().map(
//       (response: Response) => <string>response.json()).catch(this.handleError);
//   }

//   public GetFormFileDataForNew(Id:number): Observable<string> {
//     const options = {
//       params: new HttpParams().set('Id', Id.toString())
//     };
//     return this._http.get("api/SaftyForms/GetFormFileDataNEW", options).share().map(
//       (response: Response) => <string>response.json()).catch(this.handleError);
//   }
  
  /// Safety Inspection Search

  public GetSafetyInspectionSearch(): Observable<SafetyInpsectionSearchVM> {
    return this._http.get<SafetyInpsectionSearchVM>("api/SafetyDashboard/SearchSafetyInspection")
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SearchByParametersForSafetyInspectionSearch_(_SearchByParameters: SearchByParametersSafetySearchVM): Observable<FormUploadVM[]> {
    const options = {
      params: new HttpParams()
        .set('DateCompletedStart', _SearchByParameters.DateCompletedStart)
        .set('DateCompletedEnd', _SearchByParameters.DateCompletedEnd.toString())
        .set('Departments', _SearchByParameters.Departments.toString())
        .set('WorkAreas', _SearchByParameters.WorkAreas.toString())
        .set('Categories', _SearchByParameters.ChecklistCategories.toString())
        .set('Questions', _SearchByParameters.ChecklistQuestions.toString())
        .set('Contractors', _SearchByParameters.Contractors.toString())
        .set('States', _SearchByParameters.States.toString())
        .set('FollowUpRequired', _SearchByParameters.FollowUpRequired.toString())
        .set('FollowUpCompleted', _SearchByParameters.FollowUpCompleted.toString())
        .set('OnlyUnsafe', _SearchByParameters.OnlyUnsafe.toString())
        .set('OnlyInspections', _SearchByParameters.OnlyInspections.toString())
        .set('ExcludeNA', _SearchByParameters.ExcludeNA.toString())
    };
  
    return this._http.get<FormUploadVM[]>("api/SafetyDashboard/SearchByParametersForSafetyInspectionSearch", options)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public SearchByParametersForSafetyInspectionSearch(params: SearchByParametersSafetySearchVM): Observable<InspectionSearchResultsVM[]> {
    return this._http.post<InspectionSearchResultsVM[]>("api/SafetyDashboard/SearchByParametersForSafetyInspectionSearch", params)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UploadDigitalFormQuestionImage(params: UploadDigitalFormQuestionImageVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/UploadDigitalFormQuestionImage", params)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public UpdateDigitalFormName(params: UpdateDigitalFormNameVM): Observable<number> {
    return this._http.post<number>("api/SafetyDigitalForm/UpdateDigitalFormName", params)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
//   public GetSafetyInspectionSearch(): Observable<SafetyInpsectionSearchVM> {
    
//     return this._http.get("api/SafetyDashboard/SearchSafetyInspection").share().map(
//       (response: Response) => <SafetyInpsectionSearchVM>response.json()).catch(this.handleError);
//   }

//   public SearchByParametersForSafetyInspectionSearch_(_SearchByParameters:SearchByParametersSafetySearchVM): Observable<FormUploadVM[]> {
// //console.log("search data", params )
// const options = {
//   params: new HttpParams().set('DateCompletedStart', _SearchByParameters.DateCompletedStart)
//   .set('DateCompletedEnd', "" + _SearchByParameters.DateCompletedEnd)
//     .set('Departments', "" + _SearchByParameters.Departments)
//     .set('WorkAreas', "" + _SearchByParameters.WorkAreas)
//     .set('Categories', "" + _SearchByParameters.ChecklistCategories)
//     .set('Questions', "" + _SearchByParameters.ChecklistQuestions)
//     .set('Contractors', "" + _SearchByParameters.Contractors)
//     .set('States', "" + _SearchByParameters.States)
//     .set('FollowUpRequired', "" + _SearchByParameters.FollowUpRequired)
//     .set('FollowUpCompleted', "" + _SearchByParameters.FollowUpCompleted)
//     .set('OnlyUnsafe', "" + _SearchByParameters.OnlyUnsafe)
//     .set('OnlyInspections', "" + _SearchByParameters.OnlyInspections)
//     .set('ExcludeNA', "" + _SearchByParameters.ExcludeNA)
// };
//     return this._http.get("api/SafetyDashboard/SearchByParametersForSafetyInspectionSearch", options).share().map(
//       (response: Response) => <FormUploadVM[]>response.json()).catch(this.handleError);
//   }


//   public SearchByParametersForSafetyInspectionSearch(params:SearchByParametersSafetySearchVM): Observable<InspectionSearchResultsVM[]> {
//     return this._http.post("api/SafetyDashboard/SearchByParametersForSafetyInspectionSearch", params).share().map(
//         (response: Response) => <InspectionSearchResultsVM[]>response.json()).catch(this.handleError);
//   }

//   public UploadDigitalFormQuestionImage(params:UploadDigitalFormQuestionImageVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/UploadDigitalFormQuestionImage", params).share().map(
//         (response: Response) => <number>response.json()).catch(this.handleError);
//   }

//   public UpdateDigitalFormName(params:UpdateDigitalFormNameVM): Observable<number> {
//     return this._http.post("api/SafetyDigitalForm/UpdateDigitalFormName", params).share().map(
//         (response: Response) => <number>response.json()).catch(this.handleError);
//   }

  // public OrderDwonForQuestions(FormId:number,Order:number,catId:number): Observable<string> {
  //   let params: URLSearchParams = new URLSearchParams();
  //   params.set('FormId', "" + FormId);
  //   params.set('Order', "" + Order);
  //   params.set('catId', "" + catId);

  //   return this._http.get("api/SafetyDigitalForm/OrderDwonForQuestions",{ search: params }).share().map(
  //     (response: Response) => <string>response.json()).catch(this.handleError);
  // }

public OrderDwonForQuestions(FormId: number, Order: number, catId: number): Observable<string> {
  let params = new HttpParams()
    .set('FormId', FormId.toString())
    .set('Order', Order.toString())
    .set('catId', catId.toString());

  return this._http.get<string>("api/SafetyDigitalForm/OrderDwonForQuestions", { params })
    .pipe(
      share(),
      map(response => response as string),
      catchError(this.handleError)
    );
}
  // public OrderUpForQuestions(FormId:number,Order:number,catId:number): Observable<string> {
  //   let params: URLSearchParams = new URLSearchParams();
  //   params.set('FormId', "" + FormId);
  //   params.set('Order', "" + Order);
  //   params.set('catId', "" + catId);

  //   return this._http.get("api/SafetyDigitalForm/OrderUpForQuestions",{ search: params }).share().map(
  //     (response: Response) => <string>response.json()).catch(this.handleError);
  // }

public OrderUpForQuestions(FormId: number, Order: number, catId: number): Observable<string> {
  let params = new HttpParams()
    .set('FormId', FormId.toString())
    .set('Order', Order.toString())
    .set('catId', catId.toString());

  return this._http.get<string>("api/SafetyDigitalForm/OrderUpForQuestions", { params })
    .pipe(
      share(),
      map(response => response as string),
      catchError(this.handleError)
    );
}
  
public GetFacilitator(): Observable<string> {   
  return this._http.get<string>("api/PerfomeInduction/GetFacilitator")
    .pipe(
      share(),
      catchError(this.handleError)
    );
}

public GetAllInduction(): Observable<InductionM[]> {
  return this._http.get<InductionM[]>('api/PerfomeInduction/GetAllInduction')
    .pipe(
      share(),
      catchError(this.handleError)
    );
}

public gtAllSafetForms(): Observable<Form[]> {
  return this._http.get<Form[]>('api/SaftyForms/gtAllSafetForms')
    .pipe(
      share(),
      catchError(this.handleError)
    );
}
  // public GetFacilitator(): Observable<string> {   
  //   return this._http.get("api/PerfomeInduction/GetFacilitator").share().map(
  //     (response: Response) => <string>response.json()).catch(this.handleError);
  // }

  // public GetAllInduction(): Observable<InductionM[]> {
  //   return this._http.get('api/PerfomeInduction/GetAllInduction').share().map(
  //     (response: Response) => <InductionM[]>response.json()).catch(this.handleError);
  // }


  //   public gtAllSafetForms(): Observable<Form[]> {
  //   return this._http.get('api/SaftyForms/gtAllSafetForms').share().map(
  //     (response: Response) => <Form[]>response.json()).catch(this.handleError);
  // }

  // public getUsersForTraningReg(info:TraningRegSearchParametersVM): Observable<TraningRegUserVM[]> {
  
  //   return this._http.post("api/SaftyForms/getUsersForTraningReg",info).share().map(
  //     (response: Response) => <TraningRegUserVM[]>response.json()).catch(this.handleError);
  // }

  // public GetFormsForSelectedPositions(info:TraningRegSearchParametersVM): Observable<Form[]> {
  
  //   return this._http.post("api/SaftyForms/GetFormsForSelectedPositions",info).share().map(
  //     (response: Response) => <Form[]>response.json()).catch(this.handleError);
  // }

  //  public GetUsersForSelectedPositions(info:TraningRegSearchParametersVM): Observable<UserOverviewModel[]> {
  
  //   return this._http.post("api/SaftyForms/GetUsersForSelectedPositions",info).share().map(
  //     (response: Response) => <UserOverviewModel[]>response.json()).catch(this.handleError);
  // }
  // public searchTraingRegister(info:TraningRegSearchParametersVM): Observable<TrainingRegFormsVM[]> {
  
  //   return this._http.post("api/SaftyForms/searchTraingRegister",info).share().map(
  //     (response: Response) => <TrainingRegFormsVM[]>response.json()).catch(this.handleError);
  // }

  // public getSelectedFormsForSearch(info:TraningRegSearchParametersVM): Observable<SearchFormVM[]> {
  
  //   return this._http.post("api/SaftyForms/getSelectedFormsForSearch",info).share().map(
  //     (response: Response) => <SearchFormVM[]>response.json()).catch(this.handleError);
  // }

  public getUsersForTraningReg(info: TraningRegSearchParametersVM): Observable<TraningRegUserVM[]> {
    return this._http.post<TraningRegUserVM[]>("api/SaftyForms/getUsersForTraningReg", info)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetFormsForSelectedPositions(info: TraningRegSearchParametersVM): Observable<Form[]> {
    return this._http.post<Form[]>("api/SaftyForms/GetFormsForSelectedPositions", info)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public GetUsersForSelectedPositions(info: TraningRegSearchParametersVM): Observable<UserOverviewModel[]> {
    return this._http.post<UserOverviewModel[]>("api/SaftyForms/GetUsersForSelectedPositions", info)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public searchTraingRegister(info: TraningRegSearchParametersVM): Observable<TrainingRegFormsVM[]> {
    return this._http.post<TrainingRegFormsVM[]>("api/SaftyForms/searchTraingRegister", info)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  
  public getSelectedFormsForSearch(info: TraningRegSearchParametersVM): Observable<SearchFormVM[]> {
    return this._http.post<SearchFormVM[]>("api/SaftyForms/getSelectedFormsForSearch", info)
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
  // public AddtoArchive(FormUploadedId:number, isArchived:boolean): Observable<boolean> {
  //   let params: URLSearchParams = new URLSearchParams();

  //   params.set('FormUploadedId', "" + FormUploadedId);
  //   params.set('isArchived', "" + isArchived);

  //   return this._http.get("api/SaftyForms/AddtoArchive",{ search: params }).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }

  
public AddtoArchive(FormUploadedId: number, isArchived: boolean): Observable<boolean> {
  let params = new HttpParams()
    .set('FormUploadedId', FormUploadedId.toString())
    .set('isArchived', isArchived.toString());

  return this._http.get<boolean>("api/SaftyForms/AddtoArchive", { params })
    .pipe(
      share(),
      map(response => response as boolean),
      catchError(this.handleError)
    );
}

public saveAllArchivedForms(info: FormUploadVM[]): Observable<boolean> {
  return this._http.post<boolean>("api/SaftyForms/saveAllArchivedForms", info)
    .pipe(
      share(),
      catchError(this.handleError)
    );
}
//   public saveAllArchivedForms(info:FormUploadVM[]): Observable<boolean> {
  
//     return this._http.post("api/SaftyForms/saveAllArchivedForms",info).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   }

}
